import {
    Alert,
    Button,
    Container,
    Icon,
    Stack,
    ToggleButton,
    ToggleButtonGroup,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { ForumService, IdeaDto } from "../../../api/psc";
import {
    EmptyListMessage,
    HelpIconButton,
    PageHeader,
    Spinner,
} from "../../../components/exports";
import { DialogContext } from "../../../contexts/DialogContext";
import useDynamicList from "../../../hooks/UseDynamicList";
import Support from "../../etc/dialogs/Support";
import IdeaListItem from "../Components/IdeaListItem";
import CreateOrUpdateIdeaDialog from "../Dialogs/CreateOrUpdateIdeaDialog";

enum IdeaType {
    Public = 1,
    Private = 2,
}

export default function Ideas() {
    const [type, setType] = useState<IdeaType>(IdeaType.Public);
    const manager = useDynamicList<IdeaDto>((offset) => {
        if (type === IdeaType.Public) {
            return ForumService.listPublicIdeas("1", offset);
        } else if (type === IdeaType.Private) {
            return ForumService.listPrivateIdeas("1", offset);
        }
    });

    const { openDialog } = useContext(DialogContext);

    useEffect(() => {
        manager.reload();
    }, [type]);

    const handleTypeChange = (
        event: React.MouseEvent<HTMLElement>,
        value: IdeaType
    ) => {
        if (!value) {
            return;
        }
        setType(value);
    };

    const onIdeaCreated = () => {
        manager.reload();
    };

    const onIdeaChanged = (idea: IdeaDto) => {
        manager.unshiftOrReplace(idea, (i: IdeaDto) => {
            return i.id === idea.id;
        });
    };

    const openCreateIdeaDialog = () => {
        openDialog(
            <CreateOrUpdateIdeaDialog onCreateOrUpdate={onIdeaCreated} />
        );
    };

    const openSupportDialog = () => {
        openDialog(<Support />);
    };

    return (
        <Container maxWidth="sm">
            <PageHeader
                title="پیشنهادات"
                action={
                    <Stack direction="row" spacing={2}>
                        <HelpIconButton tag="forum" />
                        <Button
                            variant="contained"
                            onClick={openCreateIdeaDialog}
                            startIcon={<Icon>add</Icon>}
                        >
                            تیکت جدید
                        </Button>
                    </Stack>
                }
            />

            <Alert
                severity="warning"
                action={
                    <Button
                        size="small"
                        variant="outlined"
                        startIcon={<Icon>call</Icon>}
                        onClick={openSupportDialog}
                    >
                        تماس با پشتیبانی
                    </Button>
                }
                sx={{ mb: 2 }}
            >
                در این قسمت پیشنهادات در جهت بهبود روند سیستم دارید با ما در
                میان بگذارید و در غیر این صورت با پیشتیبانی تماس حاصل فرمایید
            </Alert>

            <ToggleButtonGroup
                fullWidth
                color="primary"
                value={type}
                exclusive
                onChange={handleTypeChange}
            >
                <ToggleButton value={IdeaType.Public}>عمومی</ToggleButton>
                <ToggleButton value={IdeaType.Private}>اختصاصی</ToggleButton>
            </ToggleButtonGroup>

            {manager.requestInProgress && <Spinner />}

            {manager.empty && <EmptyListMessage message="تیکتی یافت نشد" />}

            <Stack sx={{ mt: 2 }} spacing={2}>
                {manager.results.map((i) => {
                    return (
                        <IdeaListItem
                            key={i.id}
                            idea={i}
                            onChange={onIdeaChanged}
                        />
                    );
                })}
            </Stack>
        </Container>
    );
}
